module.exports = "/lucky-balls/img/icons/favicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/icons/favicon.png
// module id = 1064
// module chunks = 0